
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

@Options({
  methods: {
    ...mapActions(['updateStatusLogin']),
  },
})
export default class Login extends Vue {
  updateStatusLogin!: (status: boolean) => void;

  fadeOut = false;

  async goHome(): Promise<void> {
    this.updateStatusLogin(true);
    this.fadeOut = true;
    await setTimeout(() => {
      this.$router.push({ name: 'Home' });
    }, 500);
  }
}
